import Highcharts from 'highcharts';

export const createDefaultPlotOptions = (
  showChartLabels: boolean,
  presentationFont: boolean,
): Highcharts.PlotOptions => ({
  series: {
    marker: {
      fillColor: '#FFFFFF',
      lineWidth: 2,
      lineColor: null, // inherit from series
    },
    connectNulls: true,
    dataLabels: {
      inside: true,
      enabled: showChartLabels,
      className: 'bar-chart-data-labels',
      align: 'center',
      verticalAlign: 'top',
      formatter () {
        return parseFloat(this.y.toFixed(2)).toLocaleString();
      },
      style: {
        textOutline: 'none',
        fontFamily: 'Lato',
        color: 'black',
        fontSize: presentationFont ? '11px' : '9px',
      },
    },
  },
  pie: {
    animation: false,
    enableMouseTracking: false,
    borderWidth: 0,
    colors: ['#3BC1E5', '#eceff2'],
    dataLabels: {
      useHTML: true,
      enabled: false,
      softConnector: false,
      distance: -70,
      style: {
        fontSize: '34px',
        color: '#3BC1E5',
      },
    },
    innerSize: '90%',
    slicedOffset: 0,
    shadow: {
      opacity: 1,
      width: 0.7,
    },
  },
  column: {
    grouping: true,
    pointWidth: null,
    groupPadding: 0.2, // probably gonna have to add some logic here for grouped points?
    pointPadding: 0.1,
    borderWidth: 0,
    maxPointWidth: 50,
    dataLabels: {
      inside: true,
      enabled: showChartLabels,
      className: 'bar-chart-data-labels',
      align: 'left',
      verticalAlign: 'top',
      y: -20,
      x: -5,
      style: {
        textOutline: 'none',
        fontFamily: 'Lato',
        color: '#596373',
        fontSize: presentationFont ? '11px' : '9px',
      },
      formatter () {
        return parseFloat(this.y.toFixed(2)).toLocaleString();
      },
    },
  },
});
